import React from 'react';
import PropTypes from 'prop-types';

import { pure } from '@dbk/ui-react-utils';

function MaturitiesIcon(props) {
  const {
    color,
    ...svgProps
  } = props;

  return (
    <svg
      {...svgProps}
      viewBox="-1 -2 25 24"
      role="presentation"
    >
      <g fill="none" fillRule="evenodd" stroke={color}>
        <ellipse cx="5.097" cy="16.735" rx="5.097" ry="5.163" />
        <ellipse cx="16.478" cy="7.255" rx="7.163" ry="7.255" />
      </g>
    </svg>






  );
}

MaturitiesIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

MaturitiesIcon.defaultProps = {
  height: 22,
  width: 24,
};

export default pure(MaturitiesIcon);
